<script>
    export default {
        name: 'WarehouseMixin',
        methods: {
            setSelectedWarehouse(userId, warehouseId) {
                this.$store.commit('warehouse/setWarehouseId', {
                    userId: userId,
                    warehouseId: warehouseId
                });
            }
        }
    }
</script>
